module.exports = __webpack_public_path__ + "static/media/counter-bg-1.18894109.jpg";